import {
  Box,
  Image,
  useStyleConfig,
  Button,
  Heading, List, Flex, Center, Text, Link, Select,
} from '@chakra-ui/react';
import { getUsefulVars } from '../../../handlers/helpers';
import React, { useEffect } from 'react';
import { updateSectionData } from '../../../handlers/utils';
import DownloadModal from '../../../components/Modal/DownloadModal';
import { FaDownload } from 'react-icons/fa';
import { openPreview } from '../../../components/Preview/utils';
import BorderBox from '../../../components/Wrappers/BorderBox';
import MenuList from '../../Menu/MenuList';
import MenuItem from '../components/MenuItem';
import { handleQuestionSelect, interviewCoachLink } from './utils';


const InterviewCoachHome = ({ props }) => {
  const uv = getUsefulVars(props);
  const imgSrc = uv.stateProps.domain + '/app/images/interview_coach.png';
  const sectionIndex = uv.stateProps.sectionData.sectionIndex;
  const menuSectionName = window.appType === 'city' ? 'menu-grow' : 'menu-interview';
  const sections = props.navSections[menuSectionName].sections;
  const navSections = props.navSections;
  uv.stateProps.setInterviewTitle('Interview Coach');
  const variant = 'wrapper';
  const styles = {};
  styles.interview = useStyleConfig('Interview', { variant });
  styles.button = useStyleConfig('Button', { variant });
  const questions = [];
  questions['question1'] = 'Tell me about yourself.';
  questions['question2'] =  'What are your greatest strengths?';
    questions['question3'] =  'Tell me about a time you faced a challenge at work. How did you handle it?';
    questions['question4'] =  'Why should we hire you?';
    questions['question5'] =  'Do you have any questions for us?';

  useEffect(() => {
    if (sectionIndex !== 0) {
      updateSectionData({ sectionIndex: 0 }, uv.stateProps);
    }
  }, [sectionIndex]);
  return (
    <Box>
      <Box display="flex" justifyContent="space-between" width="100%">
        <Heading variant="section" pb={['32px', '32px', '40px']}>
          Mock Interview
        </Heading>
      </Box>
      <BorderBox>
        <Box display='flex' justifyContent='space-evenly'>
          {imgSrc !== '' && (
            <Center
              sx={{ width: '350px', overflow: 'hidden', margin: '0 -60px 0 0' }}
            >
              <Image
                sx={{
                  width: [0, 0, '400px'],
                  position: 'relative',
                  objectFit: 'contain',
                  zIndex: -1,
                }}
                src={imgSrc}
              />
            </Center>
          )}
          <MenuList>
            <Heading fontSize="24px" marginBottom='-1rem !important'>Which interview response do you want to practice?</Heading>
            <Text fontStyle='italic'>Our AI coach can provide you real-time feedback on the content and delivery of your interview responses.</Text>
            <Box mt={4}>
              <Heading fontSize="16px" marginBottom="1rem !important">Select a Question</Heading>
              <Select
                placeholder="Select a question to practice..."
                onChange={(e) => handleQuestionSelect(e,props,uv)}

                h="50px"
                focusBorderColor="#dd1198"
              >
                <option value={questions['question1']}>{questions['question1']}</option>
                <option value={questions['question2']}>{questions['question2']}</option>
                <option value={questions['question3']}>{questions['question3']}</option>
                <option value={questions['question4']}>{questions['question4']}</option>
                <option value={questions['question5']}>{questions['question5']}</option>
              </Select>
            </Box>
          </MenuList>
        </Box>
      </BorderBox>
    </Box>
  );

};

export default InterviewCoachHome;